import { GET_INVOICES } from "../actions/types";
const initialState = {
    list: null
};

function invoiceReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_INVOICES:
            return {
                ...state,
                list: payload
            };
        default:
            return state;
    }
}

export default invoiceReducer;
